export const RESOURCE_WARNING = 'Please Enter a valid name and role';
export const RESOURCE_HEADING = 'Resources';
export const PROJECT_START_DATE = 'Start Date';
export const PROJECT_DESCRIPTION = 'Description';
export const PROJECT_STATUS = 'Status';
export const ROLE_OPTION_MANAGER = 'Manager';
export const ROLE_OPTION_NON_MANAGER = 'Team Member';
export const ROLE_LABEL = 'Role';
export const ADD_PROJECT_TEXT = 'Add Project';
export const ADD_EMPLOYEES_TEXT = 'Add Employees';
export const SEARCH_PROJECT_TEXT = 'Search Project';
export const WARNING_TEXT_FIRST = 'You are about to ';
export const WARNING_TEXT_SECOND = '. Do you wish to continue?';
export const YES_TEXT = 'Yes';
export const NO_TEXT = 'No';
export const PROJECT_CONFIRMATION_INACTIVE = 'You are about to disable ';
export const PROJECT_CONFIRMATION_ACTIVE = 'You are about to activate ';
export const CONTINUE_CONFIRMATION = '. Continue?';
